"use strict";

function formatUrl(url) {
  let httpString = "http://",
      httpsString = "https://";
  if (url.substr(0, httpString.length) !== httpString && url.substr(0, httpsString.length) !== httpsString) url = httpsString + url;
  return url;
}

let $modalContainer = $('.page-with-quote-form');

$.fn.quoteform = function () {
  let currentSectionIndex = 1;
  $("#pagepiling").pagepiling({
    easing: "linear",
    scrollingSpeed: 300,
    sectionSelector: ".form-quote__section",
    afterLoad: function (anchorLink, index) {
      currentSectionIndex = index;
    }
  });
  $.fn.pagepiling.setAllowScrolling(false);
  $.fn.pagepiling.setKeyboardScrolling(false);
  let $this = $(this);
  let $quoteForm = $this.find(".quote-form");
  let $sections = $quoteForm.find(".form-quote__section");
  let sectionButtonSelector = ".quote-form__button";
  let $sectionButtonSelectorPrev = $(".quote-form__button-prev");
  let formItem = ".quote-form__list-item";
  let inputLabel = ".quote-form__toggle-label";
  let errorMessageElement = ".quote-form__error-message";
  $(window).keypress(function (e) {
    let key = e.which;
    let isOpenedQuoteForm = $modalContainer.css('display') === 'block';

    if (isOpenedQuoteForm && key === 13) {
      let currentSection = $($sections[currentSectionIndex - 1]);
      let nextButton = currentSection.find(sectionButtonSelector);
      nextButton.click();

      if (nextButton.length === 0) {
        currentSection.pagepiling.moveSectionDown();
      }

      return false;
    }
  });
  let constraints = {
    website: {
      presence: {
        allowEmpty: false,
        message: function (value, attribute) {
          validateField($quoteForm, formItem, errorMessageElement, value, attribute, "Please fill this in");
        }
      },
      url: {
        message: function (value, attribute) {
          validateField($quoteForm, formItem, errorMessageElement, value, attribute, "Hmm…that web address doesn't exist");
        }
      }
    },
    email: {
      presence: {
        allowEmpty: false,
        message: function (value, attribute) {
          validateField($quoteForm, formItem, errorMessageElement, value, attribute, "Please fill this in");
        }
      },
      email: {
        message: function (value, attribute) {
          validateField($quoteForm, formItem, errorMessageElement, value, attribute, "Hmm…that email doesn't look valid");
        }
      }
    }
  };
  $(document).ready(function () {
    $sectionButtonSelectorPrev.click(function () {
      $.fn.pagepiling.moveSectionUp();
    });
    $quoteForm.find(".form-quote__section").each(function (index) {
      $(this).attr("data-anchor", `section-${index}`);
    });
    $('[name="website"]').blur(function () {
      let currentURL = $(this).val();

      if (currentURL) {
        $(this).val(formatUrl(currentURL));
      }
    }).keypress(function (e) {
      let key = e.which;

      if (key === 13) {
        let currentURL = $(this).val();

        if (currentURL) {
          $(this).val(formatUrl(currentURL));
        }
      }
    });
    $('[name="helpcenter"]').blur(function () {
      let currentURL = $(this).val();

      if (currentURL) {
        $(this).val(formatUrl(currentURL));
      }
    }).keypress(function (e) {
      let key = e.which;

      if (key === 13) {
        let currentURL = $(this).val();

        if (currentURL) {
          $(this).val(formatUrl(currentURL));
        }
      }
    });
    $quoteForm.find(sectionButtonSelector).click(function (e) {
      let item = $(e.target).closest(formItem);
      let input = item.find("input")[0];
      let hasErrors = false;

      if (typeof input === "undefined") {
        item.pagepiling.moveSectionDown();
        return;
      }

      let name = input.name;
      let value = input.value;
      let fieldConstraint = constraints[name];
      let errors = validate({
        [name]: value === "" ? null : value
      }, {
        [name]: fieldConstraint
      });

      if (typeof errors !== "undefined") {
        hasErrors = errors[name].length > 0;
      }

      if (hasErrors) {
        $(item).removeClass("show-button").removeClass("validated").addClass("has-errors");
      } else if (!hasErrors && input.value !== "" || item.hasClass("quote-form__list-item--no-validation")) {
        $(item).addClass("validated").removeClass("has-errors");
        item.pagepiling.moveSectionDown();
      }
    });
    $quoteForm.find(":radio").next(inputLabel).click(function (e) {
      setTimeout(function () {
        $(e.target).pagepiling.moveSectionDown();
      }, 300);
    });
    $quoteForm.find(".quote-form__input").change(function (e) {
      var item = $(e.target).closest(formItem);
      $(item).removeClass("has-errors");

      if (e.target.value === "") {
        $(item).removeClass("show-button");
      } else if (e.target.value !== "") {
        $(item).addClass("show-button");
      }
    });
    $quoteForm.submit(function (event) {
      event.preventDefault();
      var captcha_settings = $quoteForm.find("input[name='captcha_settings']").val();
      var orgid = $quoteForm.find("input[name='orgid']").val();
      var retURL = "https://";
      var priority = $quoteForm.find("input[name='priority']").val();
      var status = $quoteForm.find("input[name='status']").val();
      var email = $quoteForm.find("input[name='email']").val();
      var name = $quoteForm.find("input[name='name']").val();
      var phone = $quoteForm.find("input[name='phone']").val();
      var origin = $quoteForm.find("input[name='origin']").val();
      var recaptchaResponse = $quoteForm.find("input[name='quoteFormCaptcha']").val();
      var hiddenRecaptcha = $quoteForm.find("input[name='hiddenRecaptcha']").val();
      var location = window.location.href;
      var values = getValues($(this));
      var newValues = {};
      var roistat = ZDT.getCookie("roistat_visit");
      Object.entries(values).forEach(([key, value]) => {
        if (value === "") {
          newValues[key] = null;
        } else {
          newValues[key] = value;
        }
      });
      var errors = validate(newValues, constraints);

      if (errors) {
        var firstInputWithErrorsName = Object.entries(errors)[0][0];
        Object.entries(errors).forEach(([key]) => {
          $quoteForm.find(`input[name="${key}"]`).closest(formItem).removeClass("show-button").addClass("has-errors");
        });
        var sectionWithError = $quoteForm.find(`.quote-form__input[name="${firstInputWithErrorsName}"]`).closest(".form-quote__section");
        var sectionWithErrorsAnchor = sectionWithError.data("anchor");
        sectionWithError.pagepiling.moveTo(sectionWithErrorsAnchor);
        return false;
      }

      if (!formQouteRecaptchaSubmitFlag) {
        $quoteForm.find(":submit").closest(formItem).addClass("has-errors");
        return false;
      }

      $quoteForm.find(":submit").closest(formItem).removeClass("has-errors");
      var result = Object.entries(values).reduce((acc, [key, value]) => {
        var label = $(this).find(`*[data-input-label="${key}"]`).text().trim().replace("*", "");
        var printValue = value.length === 0 ? "_" : value;
        acc += label + "\n" + printValue + "\n\n";
        return acc;
      }, "");
      var details = {
        captcha_settings: captcha_settings,
        orgid: orgid,
        retURL: retURL,
        priority: priority,
        status: status,
        origin: origin,
        "00N1n00000SZMvN": location,
        "00N1n00000T8LpC": 1,
        "00N1n00000TT9eY": roistat,
        name: name,
        email: email,
        phone: phone,
        subject: "Quote Request",
        description: result,
        "g-recaptcha-response": recaptchaResponse,
        hiddenRecaptcha: hiddenRecaptcha,
        submit: "Submit"
      };
      var formBody = [];

      for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }

      formBody = formBody.join("&");
      var url = "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
      fetch(url, {
        method: "Post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        mode: "no-cors",
        body: formBody
      }).then(response => {
        return response;
      });
      const quoteEmailValue = $('.quote-form__input[name="email"]').val();
      analytics.identify(null, {
        email: quoteEmailValue
      });
      analytics.track('GetAQuote');
      $quoteForm.addClass("hidden");
      $("[data-quote-form-thank-you]").removeClass("hidden");
      document.getElementById("quote-form").reset();
    });
  });
};

function getValues(values) {
  var namesToFilter = {
    captcha_settings: 1,
    orgid: 1,
    retURL: 1,
    priority: 1,
    status: 1,
    origin: 1,
    "00N1n00000SZMvN": 1,
    "00N1n00000T8LpC": 1,
    hiddenRecaptcha: 1,
    quoteFormCaptcha: 1,
    "g-recaptcha-response": 1
  };
  return values.serializeArray().filter(item => {
    if (!namesToFilter[item.name]) {
      return item;
    }
  }).reduce((acc, item) => {
    if (!acc[item.name]) {
      acc[item.name] = item.value;
    } else {
      acc[item.name] += ", " + item.value;
    }

    return acc;
  }, {});
}

function validateField(container, item, errorMessageElement, value, attribute, message) {
  let finalMessage = value === null ? "Please fill this in" : message;
  container.find(`input[name="${attribute}"]`).closest(item).find(errorMessageElement).text(finalMessage);
}
/*eslint-disable */


var formQouteRecaptchaSubmitFlag = false;

var formQuoteRecaptchaVerifyCallback = function (response) {
  document.getElementById('quoteFormCaptcha').value = response;
  formQouteRecaptchaSubmitFlag = true;
};

var formQuoteRecaptchaExpiredCallback = function () {
  formQouteRecaptchaSubmitFlag = false;
};

var formQuoteRecaptchaErrorCallback = function () {
  formQouteRecaptchaSubmitFlag = false;
};
/*eslint-enable */


$modalContainer.quoteform();

function openGetQuotePopup() {
  $("html, body").addClass("quote-form-open");
  $(".quote-form").removeClass("hidden");
  $("[data-quote-form-thank-you]").addClass("hidden");
  $modalContainer.css("display", "block");
}

function closeModalOnOutsideClick(e) {
  let $modalQuote = $('[data-quote-form-modal]');
  let $cookies = $('[data-cookies-bar]');
  let isOpenedQuoteForm = $modalContainer.css('display') === 'block';

  if (isOpenedQuoteForm && !$modalQuote.is(e.target) && $modalQuote.has(e.target).length === 0 && !$cookies.is(e.target) && $cookies.has(e.target).length === 0) {
    $("html, body").removeClass("quote-form-open");
    $modalContainer.hide();
    $(".quote-form").pagepiling.moveTo('section-0');
  }
}

$("[data-get-quote]").click(function (e) {
  e.stopPropagation();
  openGetQuotePopup();
  $(document).click(function (e) {
    closeModalOnOutsideClick(e);
  });
});
$("[data-quote-form-cancel]").click(function () {
  $("html, body").removeClass("quote-form-open");
  $modalContainer.hide();
  $(".quote-form").pagepiling.moveTo('section-0');
});

if (window.location.hash) {
  var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

  if (hash === "getquote") {
    openGetQuotePopup();
  }
} //textarea vertical scroll


var $textarea = $('[data-quote-field]');
autosize($textarea);
$textarea.each(function () {
  autosize(this);
}).on('autosize:resized', function () {
  console.log('textarea height updated');
});
let bundlesBanner = $("[for='theme-bundles']");

if ($(".quote-form__toggle-label").has(bundlesBanner)) {
  bundlesBanner.remove();
}